// extracted by mini-css-extract-plugin
export default {"container":"Carousel_container__ecm12","button":"Carousel_button__lWjlN","children":"Carousel_children__nOEGR","likeAnimation":"Carousel_likeAnimation__FHtRF"};